import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GoApplicationPurposeCodeEnum } from '../../constants/go-application-purpose-code-enum';

@Component({
    selector: 'app-go-application-purpose-selection',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-application-purpose-selection.component.html',
})
export class GoApplicationPurposeSelectionComponent {
    @Input() applicationPurpose!: GoApplicationPurposeCodeEnum | null;
    @Input() fccRegistrationNumber!: string | null;
    @Input() callSign!: string | null;
    @Input() applicationId!: string | null;
    @Input() orderId!: string | null;

    constructor() {}

    getPurposeText(): string {
        let purposeTextElements: (string | null)[] = [];

        switch (this.applicationPurpose) {
            case GoApplicationPurposeCodeEnum.NewLicense:
                purposeTextElements = [
                    'New License',
                    this.fccRegistrationNumber,
                ];
                break;

            case GoApplicationPurposeCodeEnum.NewLocation:
                purposeTextElements = ['New Location', this.callSign];
                break;

            case GoApplicationPurposeCodeEnum.NewFrequencies:
                purposeTextElements = ['New Frequencies', this.callSign];
                break;

            default:
                return '';
        }

        return purposeTextElements
            .filter((x) => x !== null && x !== '')
            .join(', ');
    }
}
